<script setup>
import { Head, Link, useForm, usePage } from '@inertiajs/vue3';

const form = useForm({
    first_name: "",
    mobile: "",
    email: "",
    message: ""
})

const submit = () => {
    try {
        form.post(route('contact.send'), {
            preserveScroll:false,
            onSuccess: page => {
                form.reset();
                successToast(page.props.flash.message);
            }
        });
    } catch (error) {
        errorToast('Something went wrong!');
    }
}

const handleInpute = () => {
    return form.clearErrors()
}
</script>

<template>
    <div class="lg:w-1/2 w-full sm:my-auto mt-4 wow animate__animated animate__fadeInRight">
        <h2 class="text-gray-900 xl:text-[48px] lg:text-[38px] text-[26px] font-medium title-font xl:mb-5 sm:mb-3 mb-2">{{$t("contact.contact_form_title")}}</h2>
        <p class="sm:text-lg text-base text-gray-500 mb-2">{{$t("contact.contact_option")}} <span
                class="text-primary">helpcenter@nochinta.xyz</span> </p>


        <form @submit.prevent="submit">
            <div class="sm:mb-4 mb-2">
                <label for="name" class="text-sm font-medium text-black">{{$t("contact.name")}}</label>
                <input v-model="form.first_name" @input="handleInpute" type="text" id="name" name="name"
                    class="w-full border border-gray-300 bg-[#c5e8eb] bg-opacity-[0.3]  hover:border-gray-600 focus:border-primary rounded focus:ring-0 text-sm outline-none text-gray-800 xl:py-2 sm:py-1 py-0 mt-1 leading-9 transition-colors duration-200 ease-in-out"
                    :placeholder="$t('contact.placeholder.name')" required>
                <p class="text-red-600 dark:text-red-300">{{ form.errors.first_name }}</p>
            </div>
            <div class="sm:mb-4 mb-2">
                <label for="email" class="text-sm font-medium text-black">{{$t("contact.email")}}</label>
                <input v-model="form.email" @input="handleInpute" type="email" id="email" name="email"
                    class="w-full border border-gray-300 bg-[#c5e8eb] bg-opacity-[0.3]  hover:border-gray-600 focus:border-primary rounded focus:ring-0 text-sm outline-none text-gray-800 xl:py-2 sm:py-1 py-0 mt-1 leading-9 transition-colors duration-200 ease-in-out"
                    placeholder="you@example.com" required>
                <p class="text-red-600 dark:text-red-300">{{ form.errors.email }}</p>
            </div>
            <div class="sm:mb-4 mb-2">
                <label for="mobile_number" class="text-sm font-medium text-black">{{$t("contact.phone_number")}}</label>
                <input v-model="form.mobile" @input="handleInpute" type="text" id="mobile_number" name="phone"
                    class="w-full border border-gray-300 bg-[#c5e8eb] bg-opacity-[0.3]  hover:border-gray-600 focus:border-primary rounded focus:ring-0 text-sm outline-none text-gray-800 xl:py-2 sm:py-1 py-0 mt-1 leading-9 transition-colors duration-200 ease-in-out"
                    placeholder="01700000000" required>
                <p class="text-red-600 dark:text-red-300">{{ form.errors.mobile }}</p>
            </div>
            <div class="sm:mb-6 mb-4">
                <label for="help" class="text-sm font-medium text-black">{{$t("contact.how_can_we_help")}}</label>
                <input v-model="form.message" @input="handleInpute" type="text" id="help" name="help"
                    class="w-full border border-gray-300 bg-[#c5e8eb] bg-opacity-[0.3]  hover:border-gray-600 focus:border-primary rounded focus:ring-0 text-sm outline-none text-gray-700 xl:py-2 sm:py-1 py-0 mt-1 leading-9 transition-colors duration-200 ease-in-out"
                    :placeholder="$t('contact.placeholder.how_can_we_help')" required>
                <p class="text-red-600 dark:text-red-300">{{ form.errors.message }}</p>
            </div>
            <button type="submit"
                class="flex w-full text-center justify-center items-center text-white bg-primary border-0 xl:py-2 py-1 px-8 focus:outline-none hover:bg-[#1565C0] transition duration-300 rounded xl:text-lg text-base uppercase"
                :class="{ 'opacity-25': form.processing }" :disabled="form.processing">{{ $t("contact.get_started") }}
            </button>
        </form>
    </div>
</template>

<style scoped></style>
